"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svgs_1 = require("@@/assets/svgs");
const string_utils_1 = require("@/common/string_utils");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
function default_1() {
    const maxWidth375 = (0, useMediaQuery_1.default)('(max-width:375px)');
    const maxWidth480 = (0, useMediaQuery_1.default)('(max-width:480px)');
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: maxWidth480 ? 'flex' : 'none',
            alignItems: 'center',
            columnGap: '8px',
            height: maxWidth375 ? '40px' : '44px',
            padding: '7px 11px',
            border: '0.5px solid rgba(0, 0, 0, 0.1)',
            backgroundColor: 'white',
        } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.FondeeIconOrangeSvg, {}), (0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ flex: 1, rowGap: "2px" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', columnGap: '2px' } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontSize: maxWidth375 ? '12px' : '13px', fontWeight: 700 } }, { children: "\uD3F0\uB514" })), Array.from('5star').map((_, index) => ((0, jsx_runtime_1.jsx)(svgs_1.StarFilledSvg, {}, `${_}${index}`)))] })), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontSize: maxWidth375 ? '10px' : '11px', color: 'rgba(0, 0, 0, 0.4)' } }, { children: "\uD3F0\uB514 \uC571\uC5D0\uC11C \uC5F4\uAE30" }))] })), (0, jsx_runtime_1.jsx)("a", Object.assign({ className: "no_anchor_deco", target: "_blank", rel: "noopener noreferrer", href: string_utils_1.storeUrl, css: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minWidth: maxWidth375 ? '46px' : '50px',
                    height: '100%',
                    borderRadius: '50px',
                    backgroundColor: 'var(--primary-main)',
                    color: 'white',
                    fontSize: maxWidth375 ? '12px' : '14px',
                    fontWeight: 700,
                } }, { children: "\uC5F4\uAE30" }))] })));
}
exports.default = default_1;
